var map = {
	"./en-US/main.json": [
		9371,
		872
	],
	"./ja-JP/main.json": [
		6306,
		382
	],
	"./zh-CN/main.json": [
		1911,
		467
	],
	"./zh-TW/main.json": [
		393,
		589
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3573;
module.exports = webpackAsyncContext;